const PLACEMENT_NAME = [
  'Front Page - Top Long Banner',
  'Front Page - Vertical Banner (Review & Blog Section)',
  'Landing Getting Started - Vertical Banner (Cerita Pengguna Rata Section)',
  'Detail Blog & Promo Page',
];

export default PLACEMENT_NAME;
